module.exports = __webpack_public_path__ + "static/violet_fungus-0ba3a64adc78c11e23521a6286b993a4.jpeg";